import React from 'react';
import { Chart } from 'react-google-charts';
import AppActions from '../../actions/app-actions';
//import List from '@material-ui/core/List';

export default class BarCharts extends React.Component {
  constructor(props, state) {
    super(props, state);
    const self = this;
    self.timer = null;
    self.state = {
      lconfs: [],
      cameraInfo: {},
      refreshLConfsLength: 30000,
    };
    // on render the store might not be updated so we resort to the API and let all later request go through the store
    // to be in sync with the rest of the UI
    self._refreshLocalConfs().then(result => self.setState(result));
  }

  componentDidMount() {
    var self = this;
    self.lconfsTimer = setInterval(() => self._refreshLocalConfs().then(result => self.setState(result)), self.state.refreshLConfsLength);
  }

  componentWillUnmount() {
    clearInterval(this.lconfsTimer);
  }

  _refreshLocalConfs() {
    var self = this;
    const cameras = {};

    return AppActions.getAllLocalConfs()
      .then(lconfs => {
        lconfs.forEach((lconf) => {
          if (lconf.config_details) {
            var config_details_json = JSON.parse(lconf.config_details || '{}')
            const slots = (config_details_json && config_details_json.slot_configuration && config_details_json.slot_configuration.slots) || null;
            if (slots) {
              slots.forEach((item) => {
                if (item.cameraBrand){
                  if (typeof cameras[item.cameraBrand] == 'undefined' ){
                    cameras[item.cameraBrand] = [];
                    cameras[item.cameraBrand].push(['model', 'count']);
                  }
                }
                const camera = cameras[item.cameraBrand];
                if (camera) {
                  const model = camera.find(m => m[0] === item.cameraModel);
                  if (model) {
                    model[1] += 1;
                  } else {
                    camera.push([item.cameraModel, 1]);
                  }
                }
              });
            }
          }
        });
        self.setState({cameraInfo:cameras, lconfs:lconfs});
      });
  }

  render() {
    var cameraStatistics = [];
    if (this.state.cameraInfo) {
      for (var i  in this.state.cameraInfo) {
        cameraStatistics.push(
          <div>
            <Chart
              width={'300px'}
              height={'300px'}
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={this.state.cameraInfo[i]}
              options={{
                title: i,
                chartArea: { width: '50%' },
                hAxis: {
                  minValue: 0,
                },
                legend: {
                  position:'none'
                },
                vAxis: {
                },
                isStacked: true
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div>);
      }
    }
    return (
      <div>
        <h4 className="dashboard-header">
          <span>Camera Statistics</span>
        </h4>
        <div style={Object.assign({ marginBottom: '30px', marginTop: '50px' }, this.props.styles)}>
          {cameraStatistics}
        </div>
      </div>  
    );
  }
}